import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { KbEntry } from "@shared/models/kb-entry"
import HasManyAltogether from "cc-frontend/helpers/has-many-altogether"
import type EmberStore from "cc-frontend/services/ember-store"
import { use } from "ember-could-get-used-to-this"

interface Signature {
  Element: HTMLUListElement
  Args: {
    entry: KbEntry
  }
}

export default class KbEntryPartArticleSummary extends Component<Signature> {
  @service("ember-store") declare store: EmberStore

  @use children = new HasManyAltogether<KbEntry>(() => [this.args.entry, "children", "kb-entry"])
}
